/* eslint-env browser, jquery */
/* global WOW */
import container from 'modules/section-content';
import domify from 'domify';
import Batch from 'batch';
import page from 'modules/ab-page-js';
import rg from 'modules/npm-component/require-global';
import cookieDough from 'cookie-dough';
import splash from './guardian-page.pug';
import metadata from './metadata.json';

const AB_TEST = 'cta-features-pgs';

export default function register() {
  page.redirect('/guardian', '/multifactor-authentication');
  page('/multifactor-authentication', render, loadScripts, snippets);
}

function render(ctx, next) {
  const renderOptions = {
    metadata,
    // Only pass view on client render.
    ...(ctx.init ? {} : { view: domify(splash()) })
  };
  container.render(renderOptions);

  next();
}

function loadScripts(ctx, next) {
  const batch = new Batch();

  const cookie = cookieDough();
  const abExperiments = JSON.parse(cookie.get('ajs_ab.traits'));

  if (abExperiments && abExperiments[AB_TEST]) {
    window.metricsLib.track(`ab:viewed-${AB_TEST}`, {
      experiment_id: AB_TEST,
      variation_id: abExperiments[AB_TEST],
    });
  }

  batch.push(done => {
    rg('//cdnjs.cloudflare.com/ajax/libs/wow/1.0.3/wow.min.js', 'WOW', done);
  });

  batch.push(done => {
    rg('//cdnjs.cloudflare.com/ajax/libs/gsap/1.16.1/TweenMax.min.js', 'TweenMax', done);
  });

  batch.push(done => {
    rg(
      '//cdn.rawgit.com/iamdanfox/typetype/gh-pages/jquery.typetype.min.js',
      '$.fn.typetype',
      done
    );
  });

  batch.push(done => {
    rg('//fast.wistia.com/assets/external/E-v1.js', 'Wistia', done);
  });

  batch.end(next);
}

function snippets(ctx, next) {
  // Hero intro animation
  $('.hero-flex-container .browser').addClass('animate');

  // video animation

  $('a.play-me-again').on('click', e => {
    e.preventDefault();
    playVid();
    showRePlay();
  });

  const vid = document.getElementById('guardian-video');

  function playVid() {
    if (vid) {
      vid.play();
    }
  }

  function showRePlay() {
    $('a.play-me-again').hide();
    setTimeout(() => {
      $('a.play-me-again').show();
    }, 27000);
  }

  const wow = new WOW({
    boxClass: 'placeholder-media',
    mobile: true,
    live: true,
    callback(box) {
      playVid();
      showRePlay();
    }
  });

  wow.init();

  // end video animation
}



// WEBPACK FOOTER //
// ./src/pages/guardian/guardian.js